import PropTypes from "prop-types"
import React, { useContext } from "react"

import { SignContractWizardContext } from "../../SignContractWizardContext"
import { isReviewPhase } from "../../reviewPhase"
import DocusealSigningForm from "../DocusealSigningForm"
import ReviewAgreement from "../ReviewAgreement"

const SignAgreement = ({ isSubmitting }) => {
  const { state } = useContext(SignContractWizardContext)

  return isReviewPhase(state) ? (
    <ReviewAgreement isSubmitting={isSubmitting} />
  ) : (
    <DocusealSigningForm />
  )
}

SignAgreement.propTypes = {
  isSubmitting: PropTypes.bool,
}

export default SignAgreement
